import { JetpacB2BApi } from 'api'

class TenantCatalogApi {
  static async getCatalogGroupById(id: string, faberToken: string) {
    const url = `/tenant-catalog/${id}`
    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async createTenantCatalog(
    body: ITenantCatalogBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPost(
      `tenant-catalog`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static async updateTenantCatalog(
    body: ITenantCatalogBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPut(
      `tenant-catalog`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default TenantCatalogApi

export interface ITenantCatalogBackendData {
  tenant_id: string
  product_type: string
  created_by?: string
  updated_by?: string
  tenant_catalog_group_discount: TenantCatalogGroupDiscount[]
}

export interface TenantCatalogGroupDiscount {
  catalog_group_id: string
  discount_percentage: string
  // product_type: string
}
